import React from 'react';
import { Box, Alert, Typography } from '@mui/material';
import { Schedule as ScheduleIcon } from '@mui/icons-material';

function TimelineTab({ event }) {
  return (
    <Box sx={{ textAlign: 'center', py: 8 }}>
      <ScheduleIcon sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
      <Typography variant="h5" gutterBottom>
        Időbeosztás Funkció
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Hamarosan elérhető lesz!
      </Typography>
      <Alert severity="info" sx={{ maxWidth: 600, mx: 'auto' }}>
        Itt kezelheted az esküvő napjának időbeosztását (szertartás, koktél, vacsora, stb.)
      </Alert>
    </Box>
  );
}

export default TimelineTab;